import { useState } from 'react';
import { __ } from '@wordpress/i18n';

export function ShareButton( { uri } ) {
	const [ copied, setCopied ] = useState( false );
	return (
		<button
			onClick={ () => {
				const fullUrl = new URL( uri, window.location.origin ).href;
				navigator.clipboard.writeText( fullUrl ).then( () => {
					setCopied( true );
					setTimeout( () => setCopied( false ), 2000 );
				} );
			} }
			className="px-2 py-1 text-xs border-2 border-green-dark bg-gray-light hover:bg-yellow cursor-pointer font-semibold whitespace-nowrap"
		>
			{ copied
				? __( 'Copied!', 'anacrm' )
				: `\u{1F517} ${ __( 'Share', 'anacrm' ) }` }
		</button>
	);
}
